import type { FC, ReactNode } from 'react'
import type { SiteNav } from '@/lib/content'

import Link from 'next/link'
import { Phone } from 'lucide-react'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { contact } from '@/constants/site'

interface LayoutProps {
    children: ReactNode
    nav?: SiteNav
}

export const Layout: FC<LayoutProps> = ({ children, nav }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-paper'>
            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer nav={nav} />

            <div className='h-16 lg:hidden' aria-hidden='true' />

            <div className='fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-ink-line bg-ink lg:hidden'>
                <a
                    href={contact.phoneHref}
                    className='flex items-center justify-center gap-2 border-r border-ink-line py-4 text-sm font-semibold text-paper'
                >
                    <Phone aria-hidden='true' className='size-4 text-minium' />
                    Call us
                </a>

                <Link
                    href='/contact'
                    className='flex items-center justify-center bg-minium py-4 text-sm font-semibold text-white'
                >
                    Request a quotation
                </Link>
            </div>
        </div>
    )
}
